export default (text: string): string => text
  .toString()
  .normalize('NFKD')
  .toLowerCase()
  .trim()
  .replace(/[\s|-]+/g, '_')
  .replace(/[^\w_]+/g, '')
  .replace(/__+/g, '_');
